<script setup>
import XerLoading from '@/components/XerLoading';
import XerZenomoLayout from '@/components/XerZenomoLayout';
import { useRootStore } from '@/stores';
import { useRouteExtensions } from '@/use/use-route-extensions';
import { useLoadFromPermalink } from '@/use/use-load-from-permalink';

const rootStore = useRootStore();

const routeExtensions = useRouteExtensions();
if (routeExtensions.currentRoute.value.query.k) {
  const { loadFromPermalink } = useLoadFromPermalink();
  loadFromPermalink();
} else {
  rootStore.setErrorNotFound();
}
</script>
<template>
  <xer-zenomo-layout :hide-navbar="true">
    <div class="xer-flex xer-justify-center">
      <xer-loading />
    </div>
  </xer-zenomo-layout>
</template>
